<template>
  <div class="home-results-body">
    <div>
      <div class="home-title">
        <p>应用成果</p>
        <span @click="$router.push(`/homeResults`)">查看更多 ></span>
      </div>
      <div class="home-results-swiper-body">
        <transition name="fade">
          <div
            @touchend="end"
            @touchstart="start"
            @touchmove="move"
            class="swiper"
          >
            <div
              @click="chooseItem(item, index)"
              v-for="(item, index) in imgs"
              :style="config5[index]"
              :key="item.id"
              class="swiper-list"
            >
              <span
                ><v-img
                  :attachment-id="
                    item.coverAttachment && item.coverAttachment.attachmentId
                  "
                  default-img="https://www.jfh.com/img/pic_nanjing1.a0c193fa.png"
                  style="width: 100%; height: 100%"
              /></span>
              <div>
                <p>
                  <a
                    style="color: black"
                    @click="$router.push(`/homeResults/detail?id=${item.id}`)"
                  >
                    {{ item.achvName }}
                  </a>
                </p>
                <span>
                  <a-tag color="blue">{{ item.fieldLevelOneName }}</a-tag>
                  <a-tag color="blue">{{ item.industryLevelOneName }}</a-tag>
                  <!--                  {{item.background}}-->
                </span>
              </div>
            </div>
          </div>
        </transition>
        <span class="prev" @click="prev"><a-icon type="left-circle" /></span>
        <span class="next" @click="next"><a-icon type="right-circle" /></span>
      </div>
    </div>
  </div>
</template>

<script>
import { getAchvList } from "@/api/achv";
import VImg from "@/components/VImg";
export default {
  components: {
    VImg,
  },
  data() {
    return {
      loading: true,
      currentIndex: 3, //当前中间imgs数组中index
      centerInfo: "", // 当前中间信息
      startX: "",
      endX: "",
      imgs: [
        {
          id: "南京市“互联网+软件交易服务平台”",
          index: 0,
          text: "创新政府采购模式",
          cover: "https://www.jfh.com/img/pic_nanjing1.a0c193fa.png",
        },
        {
          id: "西安智慧环保综合指挥中心",
          text: "护航智慧环保高质交付",
          index: 1,
          cover: "https://www.jfh.com/img/ic_xian1.bf6a1747.png",
        },
        {
          id: "南京鼓楼医院",
          text: "助力数字化变革",
          index: 2,
          cover: "https://www.jfh.com/img/pic_gulou1.d5a45eed.png",
        },
        {
          id: "江宁织造博物馆",
          text: "创新应用 线上化数字监理",
          index: 3,
          cover: "https://www.jfh.com/img/pic_jiangning1.a9f1c1ea.png",
        },
        {
          id: "南京医用耗材阳光监管平台",
          text: "消弭潜在风险",
          index: 4,
          cover: "https://www.jfh.com/img/pic_yiyong1.2946ee48.png",
        },
        {
          id: "金陵科技学院",
          text: "重新定义数字监理",
          index: 5,
          cover: "	https://www.jfh.com/img/pic_jinlin1.5852d32d.png",
        },
        {
          id: "智慧苏州",
          text: "解放号助力打造“数字化引领转型升级”标杆城市",
          index: 6,
          cover: "https://www.jfh.com/img/pic_suzhou1.164633ac.png",
        },
        {
          id: "智慧郑州",
          text: "解放号护航数字经济健康发展",
          index: 7,
          cover: "https://www.jfh.com/img/pic_zhengzhou1.d3b04c5e.png",
        },
      ],
      previous: 0,
      config5: [
        {
          id: "-A",
          position: "absolute",
          width: "22%",
          height: "72%",
          top: "19.2%",
          left: "-22%",
          opacity: 0,
          zIndex: 0,
          transition: ".4s",
        },
        {
          id: "A",
          position: "absolute",
          width: "22%",
          height: "72%",
          top: "19.2%",
          left: "1%",
          opacity: 1,
          zIndex: 1,
          transition: ".4s",
        },
        {
          id: "B",
          position: "absolute",
          width: "28%",
          height: "82%",
          top: "14%",
          left: "14%",
          opacity: 1,
          zIndex: 2,
          transition: ".4s",
        },
        {
          id: "center",
          position: "absolute",
          width: "35%",
          height: "90%",
          top: "9%",
          left: "50%",
          marginLeft: "-16%",
          opacity: 1,
          zIndex: 4,
          transition: ".4s",
        },
        {
          id: "D",
          position: "absolute",
          width: "28%",
          height: "82%",
          top: "14%",
          left: "61.8%",
          opacity: 1,
          zIndex: 2,
          transition: ".4s",
        },
        {
          id: "E",
          position: "absolute",
          width: "22%",
          height: "72%",
          top: "19.2%",
          left: "77%",
          opacity: 1,
          zIndex: 1,
          transition: ".4s",
        },
        {
          id: "E+",
          position: "absolute",
          width: "22%",
          height: "72%",
          top: "19.2%",
          left: "100%",
          opacity: 0,
          zIndex: 0,
          transition: ".4s",
        },
      ],
    };
  },
  mounted() {
    this.loadGetAchvList();
  },
  methods: {
    loadGetAchvList() {
      getAchvList(
        {
          size: 8,
          current: 1,
        },
        {
          field: "",
          industry: "",
          skill: "",
          keywords: "",
          sort: "Priority",
        }
      ).then((res) => {
        this.imgs = res.data.records.map((e, index) => {
          return {
            ...e,
            index,
          };
        });
      });
    },
    // 获取数据
    async getData() {
      this.$nextTick(() => {
        this.loading = false;
      });
    },
    // 滑动上一个
    prev() {
      // this.imgs.unshift(this.imgs.pop());
      this.config5.push(this.config5.shift());
      this.currentIndex = this.currentIndex - 1;
      if (this.currentIndex < 0) {
        this.currentIndex = this.imgs.length - 1;
      }
      this.centerCard();
      this.centerIndex("prev");
    },
    // 滑动下一个
    next() {
      // this.imgs.push(this.imgs.shift());
      this.config5.unshift(this.config5.pop());
      this.currentIndex = this.currentIndex + 1;
      if (this.currentIndex > this.imgs.length - 1) {
        this.currentIndex = 0;
      }
      this.centerCard();
      this.centerIndex("next");
      // console.log(this.currentIndex);
    },
    // 开始移动端滑动屏幕
    start(event) {
      this.startX = event.changedTouches[0].clientX;
      this.startY = event.changedTouches[0].clientY;
    },
    // 连续滑动
    move(event) {
      this.endY = event.changedTouches[0].clientY;
      this.endX = event.changedTouches[0].clientX;
      this.stopDefault(event);
      // 如果是滑动，注解（223行到231行）这段。如果是连续滑动，放开（223行到231行）注解
      this.interval = this.endX - this.startX;
      if (this.interval > 40) {
        this.startX = this.endX;
        this.prev();
      }
      if (this.interval < -40) {
        this.startX = this.endX;
        this.next();
      }
    },
    // 滑动
    end(/*event*/) {
      // 如果是滑动，放开（236行到238行）的注解。如果是连续滑动，注解（236行到238行）
      // this.endY = event.changedTouches[0].clientY;
      // this.endX = event.changedTouches[0].clientX;
      // this.formatSwiper();
    },
    formatSwiper() {
      if (this.startX > this.endX) {
        console.log("左边滑动");
        if (this.startX > this.endX + 40) {
          this.next();
        }
      } else {
        console.log("右边滑动");
        if (this.endX > this.startX + 40) {
          this.prev();
        }
      }
    },
    // 阻止touchmove的横向默认事件（ios快捷操作会关闭页面）
    stopDefault(event) {
      let differenceY = this.endY - this.startY;
      let differenceX = this.endX - this.startX;
      if (Math.abs(differenceX) > Math.abs(differenceY)) {
        event.preventDefault();
      }
    },
    // 当前imgs在位置上的index（并非img数组的index）
    centerIndex(val) {
      if (val == "prev") {
        for (let val of this.imgs) {
          if (val.index == this.imgs.length - 1) {
            val.index = 0;
          } else {
            val.index = val.index + 1;
          }
        }
      } else {
        for (let val of this.imgs) {
          if (val.index == 0) {
            val.index = this.imgs.length - 1;
          } else {
            val.index = val.index - 1;
          }
        }
      }
    },
    // 点击
    chooseItem(item) {
      let cycles = item.index;
      if (item.index < 3) {
        for (let i = 0; i < 3 - cycles; i++) {
          console.log(item.index);
          this.prev();
        }
      } else if (item.index > 3) {
        for (let i = -1; i < item.index - 3; i++) {
          this.next();
        }
      } else if (item.index == 3) {
        console.log("123");
      }
    },
    // 计算中间卡片信息
    centerCard() {
      this.centerInfo = this.imgs[this.currentIndex];
      this.$emit("centerInfo", this.centerInfo);
      // this.$emit('centerInfo', this.centerInfo);
      // console.log(this.imgs[2].id);
    },

    addCardStyle() {
      if (this.imgs.length > 7) {
        let addtime = this.imgs.length - 7;
        for (let i = 0; i < addtime; i++) {
          this.config5.push({
            id: "center",
            position: "absolute",
            width: "35%",
            height: "90%",
            top: "9%",
            left: "50%",
            marginLeft: "-16%",
            opacity: 0,
            transition: ".1s",
          });
        }
      }
    },
  },
  created() {
    this.getData();
    this.centerCard(); // 获取中间卡片信息
    this.addCardStyle(); // 加入样式位置的index
  },
};
</script>

<style lang="less" scoped>
.home-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  > p {
    font-size: 24px;
    line-height: 24px;
    padding-left: 12px;
    border-left: 4px solid #1abc9c;
    font-weight: 400;
  }
  > span {
    line-height: 14px;
    color: #8c8c8c;
    cursor: pointer;
  }
}
.home-results-body {
  background: #fff;
  padding: 40px 0;
  > div {
    width: 1200px;
    margin: 0 auto;
    .home-results-swiper-body {
      position: relative;
      > span {
        font-size: 30px;
        color: #bbb;
        cursor: pointer;
        position: absolute;
        top: 50%;
        &.prev {
          left: -60px;
        }
        &.next {
          right: -60px;
        }
      }
    }
  }
}
.swiper {
  width: 100%;
  height: 400px;
  position: relative;
  overflow: hidden;
  div {
    opacity: 0;
  }
  .swiper-list {
    padding: 24px;
    background: #fff;
    box-shadow: 0 0 5px -1px #ccc;
    > span {
      display: block;
      height: 70%;
      margin-bottom: 16px;
      > img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
    > div {
      opacity: 1;
      text-align: center;
      > p {
        font-size: 20px;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-bottom: 16px;
      }
      > span {
        display: block;
        font-size: 12px;
        line-height: 12px;
        color: #8c8c8c;
      }
    }
  }
}
</style>
